<script>
export default {
  props: {
    labels: {
      type: Array,
      default: () => [],
    },
    labelsNamedPagesUrls: {
      type: Object,
      default: () => ({}),
    },
    shouldDisplay: {
      type: Boolean,
      default: true,
    },
    shouldAlignStart: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    hasLabelHref(label) {
      return Object.hasOwn(this.labelsNamedPagesUrls, label);
    },
    getLabelHref(label) {
      return this.labelsNamedPagesUrls[label];
    },
  },
};
</script>

<template>
  <ul
    v-if="labels.length > 0 && shouldDisplay"
    :class="['tags tags--with-links', { 'tags--align-start': shouldAlignStart }]"
  >
    <li v-for="label in labels" :key="label" class="tags__item">
      <a v-if="hasLabelHref(label)" :href="getLabelHref(label)">{{ label }}</a>
      <span v-else>{{ label }}</span>
    </li>
  </ul>
</template>
